import * as actions from './actions';

export default (state = {}, action) => {
  switch (action.type) {
    case actions.GET_LIST.REQUEST:
      return {
        ...state,
        listFetching: true,
      };
    case actions.GET_LIST.SUCCESS:
    case actions.GET_LIST.FAILURE:
      return {
        ...state,
        listFetching: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/services/api/configuration/user-in-project/reducer.js